<div class="loading" *ngIf="show">Loading&#8230;</div>

<div class="loading-header" *ngIf="showHeader">Loading&#8230;</div>